import { render, staticRenderFns } from "./elementHint.vue?vue&type=template&id=45808ef6"
import script from "./elementHint.vue?vue&type=script&lang=js"
export * from "./elementHint.vue?vue&type=script&lang=js"
import style0 from "./elementHint.vue?vue&type=style&index=0&id=45808ef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports